export default __webpack_public_path__ + "static/media/75.c39449d5.jpeg";